import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "epoch__content decoration"
}
const _hoisted_2 = { class: "parallax-wrapper" }
const _hoisted_3 = ["src"]

import { IDecoration } from "@features/Pages/TimelineMapPage/_js/app/interfaces/IDecoration";
import { useTimelineMapService } from '../../services/timelineMapService';


export default /*@__PURE__*/_defineComponent({
  __name: 'Decoration',
  props: {
    decoration: {}
  },
  setup(__props: any) {

const props = __props;

const { trimWindowTypes } = useTimelineMapService();
const trimmedWindowType = trimWindowTypes(props.decoration.windowType);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['epoch__item', 'epoch__item--decoration', __props.decoration.illustration, `epoch__item--${_unref(trimmedWindowType)}` ])
  }, [
    (__props.decoration.view && __props.decoration.windowType)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(['timeline-window', __props.decoration.windowType])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                src: __props.decoration.view,
                class: "rellax"
              }, null, 8 /* PROPS */, _hoisted_3)
            ])
          ], 2 /* CLASS */)
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})